import type { Message } from '../type'

declare global {
  interface Window {
    BotAvatar: {
      postMessage: (message: string) => void
    }
  }
}

export const postMessage = (message: Message) => {
  const messageString = JSON.stringify(message)

  if (process.env.NODE_ENV === 'development') {
    window.BotAvatar = window.BotAvatar || {
      postMessage: (message: string) => {
        console.log('BotAvatar.postMessage', messageString)
      },
    }
  }

  if (!window.BotAvatar || !window.BotAvatar.postMessage) {
    window.BotAvatar = {
      postMessage: (message: string) => {},
    }
  }

  window.BotAvatar.postMessage(messageString)
}
